import type AjaxRequestBroker from "../AjaxRequestBroker";
import type {ApiOpts} from "@esWebAPI/es/model/Models";

export default class AppUserSupportModule {

    private readonly rqBroker: AjaxRequestBroker;
    private readonly resourceName: string;

    constructor(rqBroker: AjaxRequestBroker, resourceName: string) {
        this.rqBroker = rqBroker;
        this.resourceName = resourceName;
    }

    // ------------- SECURE -------------

    async getSupportAvailabilityForUser(opts?: ApiOpts): Promise<number> {
        return await this.rqBroker.doGetPromise({
            url: es.api.getURL(this.resourceName) + "/support_availability_for_user",
            opts: opts
        });
    }

    async setSupportAvailabilityForUser(date: number, opts?: ApiOpts): Promise<AppUserSupport> {
        return await this.rqBroker.doPutPromise({
            url: es.api.getURL(this.resourceName) + "/support_availability_for_user",
            opts: opts,
            data: [date]
        });
    }

    // ------------- UNSECURE -------------
    // Requires tenant_admin permission
    // TODO: could a case be made for putting these methods in the tenantAdmin module and only importing that module in tenantAdmin app?

    async getSupportAvailabilityForTenant(tenantId: number, opts?: ApiOpts): Promise<number[]> {
        return await this.rqBroker.doGetPromise({
            url: es.api.getURL(this.resourceName) + "/support_availability_for_tenant/" + tenantId,
            opts: opts
        });
    }

    async getTokenForUser(tenantId: number, appUserId: number, opts?: ApiOpts): Promise<string> {
        return await this.rqBroker.doGetPromise({
            url: es.api.getURL(this.resourceName) + "/token_for_user/" + tenantId + "/" + appUserId,
            opts: opts
        });
    }

    async getHistory(tenantId: number, appUserId: number, opts?: ApiOpts): Promise<AppUserSupport[]> {
        return await this.rqBroker.doGetPromise({
            url: es.api.getURL(this.resourceName) + "/history/" + tenantId + "/" + appUserId,
            opts: opts
        });
    }
}

export type AppUserSupport = {
    id: number
    lastModified: number
    created: number,
    appUserId: number,
    supportAccessDate: number | undefined,
    supportAuthToken: string | undefined
}